<template>
  <!-- prettier-ignore -->
  <div class="person-name">
    <div class="person-name__label">{{ name }}</div>
    <div
      v-if="!noAge && person.age > 0"
      class="person-name__age">
      ({{ person.age }}<template v-if="isBirthday && $browser.isDesktop"> 🎂</template>)
    </div>
  </div>
</template>

<script>
import { DateTimeHelper } from '@/helpers/DateTime'

import { PersonHelper } from '@/helpers/Person'

export default {
  name: 'PersonName',

  props: {
    noAge: {
      type: Boolean,
      default: false,
    },

    person: {
      type: Object,
      required: true,
    },
  },

  computed: {
    name() {
      if (this.person.number) {
        return this.person.personData.firstName ?? this.$t('person.person', { number: this.person.number })
      }
      return PersonHelper.getFirstName(this.person.personId, this.$t.bind(this))
    },

    isBirthday() {
      return DateTimeHelper.isBirthday(this.person.personData.dateOfBirth)
    },
  },
}
</script>

<style name="mobile" scoped>
.person-name {
  display: flex;

  &__label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__age {
    padding-left: 5px;
    white-space: nowrap;
  }
}
</style>
